import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center" };
const _hoisted_2 = { class: "flex flex-col text-xs text-gray-500 dark:text-primary-200" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.image_uploads.supports')
};
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Supports',
    props: {
        error: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('supports')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('max_size')), 1)
                ]),
                (__props.error)
                    ? (_openBlock(), _createBlock(SvgIcon, {
                        key: 0,
                        name: "warning",
                        class: "w-5 h-5 ml-2"
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
